import 'uni-pages';import '@dcloudio/uni-stat';

import Vue from 'vue'            
import Page from './pages/personalCenter/order/index.vue'
createPage(Page)